import React from "react";
import { TextField, SxProps } from "@mui/material";
import { useField } from "formik";

interface IFormikPreviewFormTextFieldProps {
  name: string;
  placeholder: string;
  labelledById?: string;
  label: string;
  sx: SxProps;
}
export const FormikPreviewFormTextField: React.FC<
  IFormikPreviewFormTextFieldProps
> = ({ name, labelledById, label, placeholder, sx }) => {
  const [field, meta, helpers] = useField<string>({
    name,
  });

  return (
    <TextField
      defaultValue={field.value}
      data-cy="text-field"
      aria-labelledby={labelledById}
      onChange={(event) => helpers.setValue(event.target.value)}
      label={label}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      fullWidth
      error={meta.touched && meta.error ? true : false}
      helperText={meta.error}
      sx={{
        backgroundColor: (theme) => ` ${theme.palette.common.white}`,
        ...sx,
      }}
    />
  );
};
